import VersionPage from './versionPage';
export default VersionPage;
